import { http } from './http';

export interface LookupItem { [key: string]: any; }
export interface LookupData { data: LookupItem[]; }

const _cache: Record<string, LookupItem[]> = {};

export async function listLookups(): Promise<string[]> {
  const r = await http<string[]>('/api/lookup');
  return Array.isArray(r) ? r : [];
}

export async function getLookup(name: string): Promise<LookupData> {
  return http<LookupData>(`/api/lookup/${name}`);
}

export async function getLookupCached(name: string): Promise<LookupItem[]> {
  if (_cache[name]) return _cache[name];
  const result = await getLookup(name);
  const items = Array.isArray(result?.data) ? result.data : [];
  _cache[name] = items;
  return items;
}
